const CNPJ_LENGTH = 14
const ZERO_CHAR_CODE = 48

export function sanitizeCNPJ(cnpj) {
  return String(cnpj || '').replace(/[^0-9A-Za-z]/g, '').toUpperCase()
}

export function isValidCNPJ(cnpj) {
  const value = sanitizeCNPJ(cnpj)
  if (value.length !== CNPJ_LENGTH) return false
  if (!/^[0-9A-Z]{12}\d{2}$/.test(value)) return false
  if (/^(.)\1+$/.test(value)) return false

  const checkDigit = (length) => {
    let sum = 0
    let weight = length - 7

    for (let i = 0; i < length; i++) {
      sum += (value.charCodeAt(i) - ZERO_CHAR_CODE) * weight--
      if (weight < 2) weight = 9
    }

    const remainder = sum % 11
    return remainder < 2 ? 0 : 11 - remainder
  }

  return checkDigit(12) === parseInt(value[12]) && checkDigit(13) === parseInt(value[13])
}
